var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-geo-json',{attrs:{"geojson":_vm.geojson,"options":{ style: _vm.styleFunction }}})}
var staticRenderFns = []

export { render, staticRenderFns }